import { Modal, Button, Box, Grid } from "@mui/material";
import { H5 } from "./Typography";

type MyModalProps = {
  open: boolean;
  handleClose: () => void;
  handleSave: () => void;
};

function TaxSavingModel({ open, handleClose, handleSave }: MyModalProps) {
  const handleSaveClick = () => {
    handleSave();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid sx={style}>
        <Box sx={header}>
          <H5
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              p: 1.5,
              color: "#ffff",
            }}
            fontWeight={"500"}
          >
            Important Information
          </H5>
        </Box>
        <Grid container sx={{ mt: 2 }} spacing={2}></Grid>
        <Box sx={container}>
          <H5
            fontWeight={400}
            sx={{ color: "#595959", fontFamily: "'Poppins', sans-serif" }}
          >
            Investments in Tax Saving Mutual Fund Schemes or ELSS (Equity Linked
            Savings Schemes) are eligible for deduction under Section 80 C of
            the Income Tax Act.
          </H5>
          <H5
            fontWeight={400}
            sx={{ color: "#595959", fontFamily: "'Poppins', sans-serif" }}
          >
            Maximum deduction permissible under Section 80C is Rs.150,000.
            Investments in ELSS are with a lock-in period of as per the Act.
          </H5>
          <Box sx={buttonContainer}>
            <Button variant="contained" onClick={handleSaveClick} sx={add}>
              Proceed
            </Button>
          </Box>
        </Box>
      </Grid>
    </Modal>
  );
}

export default TaxSavingModel;
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    md: "30%",
    xs: "90%",
  },
  bgcolor: "background.paper",
  overflowY: "scroll",
  boxShadow: 4,

  borderRadius: 2,
  overflow: "hidden",
};
const header = {
  width: "100%",
  bgcolor: process.env.REACT_APP_PRIMARY_COLOR,

  boxShadow: 4,
};
const container = {
  pl: 2,
  pr: 2,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  pb: 1.5,
  pt: 2,
};

const buttonContainer = {
  width: "100%",
  justifyContent: "space-between",
  flexDirection: {
    md: "row",
    xs: "column",
  },
  display: "flex",

  mt: {
    md: 2.5,
    xs: 1,
  },
};

const add = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: {
    md: "100%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
